import { compact } from '../../../helpers/compact';
import { DocumentType } from '../../../types/document';
import { HubActus } from '../../../types/page';
import { toImage, toText } from '../fields';
import { pageEntity } from './internal';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processHubActus = (entity: any): HubActus =>
  compact({
    uid: DocumentType.HUB_ACTUS,
    type: DocumentType.HUB_ACTUS,
    bannerLabel: toText(entity.data?.header_title),
    bannerPicture: toImage(entity.data?.header_image),
  });

const HubActualites = pageEntity<HubActus>(DocumentType.HUB_ACTUS, {
  processStrategy: processHubActus,
});

export default HubActualites;
